import { render, staticRenderFns } from "./author.vue?vue&type=template&id=d31ff00c&"
import script from "./author.vue?vue&type=script&lang=js&"
export * from "./author.vue?vue&type=script&lang=js&"
import style0 from "./author.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports